import React, { useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useHistory } from 'react-router-dom';
import { NAME_SPACE } from 'i18n';
import { FormPage, useRequestLoading, ButtonSave, ButtonBack } from 'shared';
import { PATH } from 'app.routes.const';
import { useAnalyticsReport } from './useAnalyticsReport';
import { FormAnalyticsReport } from './FormAnalyticsReport';
import { UserContext, ROLES } from 'auth';

export function EditAnalyticsReport() {
  const { id } = useParams();
  const { report, createReport, updateReport, errorInfo, setErrorInfo } = useAnalyticsReport(id);
  const { t } = useTranslation(NAME_SPACE.ANALYTICS_REPORTS);
  const $formRef = useRef(null);
  const history = useHistory();
  const { requestLoading, callbackRequest } = useRequestLoading();
  const { user } = useContext(UserContext);
  const isAdmin = user?.role === ROLES.ADMIN;

  async function handleSubmit(report) {
    await callbackRequest(async () => {
      setErrorInfo({ message: '', detail: '' });
      id ? await updateReport(report) : await createReport(report);
      history.push(PATH.ANALYTICS_REPORTS.LIST);
    });
  }

  function handleSaveClick() {
    $formRef.current.submit();
  }

  function handleGoBack() {
    history.push(PATH.ANALYTICS_REPORTS.LIST);
  }

  function composeActionButtons() {
    const actionButtons = [
      { onClick: handleGoBack, component: ButtonBack },
      ...(isAdmin
        ? [
            {
              onClick: handleSaveClick,
              enableOnDirty: true,
              component: ButtonSave
            }
          ]
        : [])
    ];

    return actionButtons;
  }

  return (
    <FormPage
      title={t('singularName')}
      disabled={requestLoading}
      buttons={composeActionButtons()}
      onSubmit={handleSubmit}
    >
      <FormAnalyticsReport errors={errorInfo} formRef={$formRef} report={{ ...report }} isReadOnly={!isAdmin} />
    </FormPage>
  );
}
